import React, { createContext, useContext, useState, ReactNode } from 'react';
import { getCookiePromptAccepted, setCookiePromptAccepted } from '../cookies';
import { updateGA4Consent } from '../common/analytics';

interface CookieConsentContextType {
	cookieConsent: boolean | null;
	setCookieConsent: (consent: boolean) => void;
	resetCookieConsent: () => void;
}

const CookieConsentContext = createContext<CookieConsentContextType | undefined>(undefined);

export const useCookieConsent = () => {
	const context = useContext(CookieConsentContext);
	if (context === undefined) {
		throw new Error('useCookieConsent must be used within a CookieConsentProvider');
	}
	return context;
};

interface CookieConsentProviderProps {
	children: ReactNode;
}

export const CookieConsentProvider: React.FC<CookieConsentProviderProps> = ({ children }) => {
	const [cookieConsent, setCookieConsentState] = useState<boolean | null>(() => getCookiePromptAccepted());

	const setCookieConsent = (consent: boolean) => {
		setCookieConsentState(consent);
		setCookiePromptAccepted(consent);
		updateGA4Consent(consent);
	};

	const resetCookieConsent = () => {
		setCookieConsentState(null);
		// Clear the cookie to force the dialog to show again
		document.cookie = 'cookie_prompt_accepted=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
	};

	return (
		<CookieConsentContext.Provider value={{
			cookieConsent,
			setCookieConsent,
			resetCookieConsent,
		}}>
			{children}
		</CookieConsentContext.Provider>
	);
}; 